import React from 'react';
import PropTypes from 'prop-types';
import GridRow from '../Grid/GridRow';
import GridColumn from '../Grid/GridColumn';
import ModalDialog from './ModalDialog';
import ModalContent from './ModalContent';
import ModalText from './ModalText';
import Button from '../Buttons/Button';

function SimpleModal(_ref) {
  var id = _ref.id,
      displayed = _ref.displayed,
      onClose = _ref.onClose,
      closeOnOverlayClick = _ref.closeOnOverlayClick,
      title = _ref.title,
      text = _ref.text,
      button = _ref.button,
      onButtonClick = _ref.onButtonClick;
  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    displayed: displayed,
    onBackdropClick: closeOnOverlayClick ? onClose : undefined
  }, /*#__PURE__*/React.createElement(ModalContent, {
    id: id,
    title: title,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(GridRow, null, /*#__PURE__*/React.createElement(GridColumn, {
    auto: true
  }, /*#__PURE__*/React.createElement(ModalText, {
    id: id + "-desc"
  }, text))), button && /*#__PURE__*/React.createElement(GridRow, {
    mt: 2
  }, /*#__PURE__*/React.createElement(GridColumn, {
    auto: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "wired",
    onClick: onButtonClick
  }, button)))));
}

SimpleModal.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  displayed: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  closeOnOverlayClick: PropTypes.bool,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.string,
  onButtonClick: PropTypes.func
} : {};
SimpleModal.defaultProps = {
  onClose: undefined,
  closeOnOverlayClick: true,
  button: undefined,
  onButtonClick: undefined
};
export default SimpleModal;